import { render } from "./SearchBar.vue?vue&type=template&id=af3e4322"
import script from "./SearchBar.vue?vue&type=script&lang=js"
export * from "./SearchBar.vue?vue&type=script&lang=js"

import "./SearchBar.vue?vue&type=style&index=0&id=af3e4322&lang=scss"
script.render = render

export default script